module.exports = __webpack_public_path__ + "static/media/miracleDefault.5a7fbba3.png";